import mock from './mock'
import './jwt'
import './pages/faq'
import './pages/knowledge-base'
import './pages/blog-data'
import './pages/chat'
import './pages/account-settings'
import './navbar/navbarSearch'
import './pages/invoice'
import './pages/profile'
import './cards/card-analytics'
import './tables/datatables'
import './tables/userList'
import './cards/card-statistics'
import './tables/permissionsList'

mock.onAny().passThrough()
